<div class="bg-white dark:bg-gray-800 rounded-lg overflow-hidden h-full">
  <!-- Loading State -->
  @if (isLoading() && isMobileView()) {
    <app-stock-accordion-skeleton [rows]="5"></app-stock-accordion-skeleton>
  } @else if (isLoading()) {
    <app-stock-table-skeleton></app-stock-table-skeleton>
  } @else if (isMobileView()) {
    <!-- Mobile Accordion View -->
    <app-stock-accordion-list
      [stocks]="stocks()"
      [isLoading]="isLoading()"
      (stockSelected)="onStockClick($event)">
    </app-stock-accordion-list>
  } @else {
    <!-- PrimeNG Table -->
    <p-table
      #stockTable
      [value]="stocks()"
      [paginator]="false"
      [scrollable]="true"

      styleClass="p-datatable-striped h-full"
      (onRowSelect)="onStockClick($event.data)"
      (onSort)="onSort($event)"
      selectionMode="single">
          <!-- scrollHeight="700px" -->

      <!-- Company Column -->
      <ng-template pTemplate="header">
        <tr>
          <th class="px-3 py-3 text-center text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
            &nbsp;
          </th>
          <th class="px-3 py-3 text-center text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider">
            Company
          </th>
          <th class="px-3 py-3 text-center text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider" pSortableColumn="currentPrice">
            Current Price <p-sortIcon field="currentPrice"></p-sortIcon>
          </th>
          <th class="px-3 py-3 text-center text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider" pSortableColumn="stickerPrice">
            Sticker Price <p-sortIcon field="stickerPrice"></p-sortIcon>
          </th>
          <th class="px-3 py-3 text-center text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider" pSortableColumn="discount">
            Discount % <p-sortIcon field="discount"></p-sortIcon>
          </th>
          <th class="px-3 py-3 text-center text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider" pSortableColumn="wsyScore">
            WSY Score <p-sortIcon field="wsyScore"></p-sortIcon>
          </th>
          <th class="px-3 py-3 text-center text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider" pSortableColumn="mgmtScore">
            Mgmt Score <p-sortIcon field="mgmtScore"></p-sortIcon>
          </th>
          <th class="px-3 py-3 text-center text-xs font-semibold text-gray-500 dark:text-gray-300 uppercase tracking-wider" pSortableColumn="growthScore">
            Growth Score <p-sortIcon field="growthScore"></p-sortIcon>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-stock>
        <tr class="cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700">
          <!-- Add to Watchlist Button -->
          <td class="px-3 py-3 whitespace-nowrap text-center">
            <app-watchlist-add-icon-button
              [ticker]="stock.ticker">
            </app-watchlist-add-icon-button>
          </td>

          <!-- Company Display -->
          <td class="px-3 py-3 whitespace-nowrap">
            <app-company-display
              [clickable]="true"
              [ticker]="stock.ticker"
              [companyName]="stock.name"
              [logoUrl]="stock.logoUrl"
              [currentPrice]="stock.currentPrice"
              [sma20]="stock.sma20"
              [sma50]="stock.sma50"
              [sma200]="stock.sma200"
              [buyPrice]="stock.buyPrice"
              (selected)="stockClicked($event)">
            </app-company-display>
          </td>

          <!-- Current Price -->
          <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white font-medium text-center">
            {{ stock.currentPrice | wsyCurrency }}
          </td>

          <!-- Sticker Price -->
          <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white text-center">
            @if (stock.stickerPrice) {
              <span>{{ stock.stickerPrice | wsyCurrency }}</span>
            } @else {
              <span class="text-gray-400 dark:text-gray-500">-</span>
            }
          </td>

          <!-- Discount % -->
          <td class="px-3 py-3 whitespace-nowrap text-sm text-gray-900 dark:text-white text-center">
            @if (stock.discount !== undefined) {
              @if (stock.discount < 0) {
                <wsy-premium-badge [show]="true"></wsy-premium-badge>
              } @else {
                <span>{{ stock.discount | wsyPercentage }}</span>
              }
            } @else {
              <span class="text-gray-400 dark:text-gray-500">-</span>
            }
          </td>

          <!-- WSY Score -->
          <td class="px-3 py-3 whitespace-nowrap text-sm text-center">
            <wsy-score-badge [score]="stock.wsyScore"></wsy-score-badge>
          </td>

          <!-- Mgmt Score -->
          <td class="px-3 py-3 whitespace-nowrap text-sm text-center">
            <wsy-score-badge [score]="stock.mgmtScore"></wsy-score-badge>
          </td>

          <!-- Growth Score -->
          <td class="px-3 py-3 whitespace-nowrap text-sm text-center">
            <wsy-score-badge [score]="stock.growthScore"></wsy-score-badge>
          </td>
        </tr>
      </ng-template>

      <!-- Empty State -->
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8" class="px-3 py-12 text-center text-gray-500 dark:text-gray-400">
            <div class="text-lg font-medium">No stocks found</div>
            <div class="text-sm mt-1">Try selecting a different collection</div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
